import Cookies from 'js-cookie';

export function viewedProducts() {
    window.addEventListener("DOMContentLoaded", (event) => {

        const productIdEl = document.querySelector('#viewedId');
        if (productIdEl) {
            const productViewdId = productIdEl.dataset.id;
            const cookieValue = Cookies.get('viewedProducts');
            const productsIdArray = cookieValue ? JSON.parse(cookieValue) : [];

            if (productsIdArray.includes(productViewdId)) return;
            productsIdArray.push(productViewdId);
            Cookies.set('viewedProducts', JSON.stringify(productsIdArray));
        }

    });
}